import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import GoogleForm1 from './views/GoogleForm1.vue'
import GooglePayResult from './views/GooglePayResult.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '',
      name: 'index',
      component: GoogleForm1
    },
    {
      path: '/enroll',
      name: 'google1',
      component: GoogleForm1
    },
    {
      path: '/orders',
      name: 'orders',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Orders.vue')
    },
    {
      path: '/result',
      name: 'result',
      component: GooglePayResult
    },
    {
      path: '/r/:referrer',
      name: 'google1b',
      component: GoogleForm1
    },
    {
      path: '/enroll/r/:referrer',
      name: 'google1b',
      component: GoogleForm1
    },
    {
      path: '/enroll/:lessonid',
      name: 'google1a',
      component: GoogleForm1
    },
    {
      path: '/enroll/:lessonid/:referrer',
      name: 'google1b',
      component: GoogleForm1
    }
  ]
})
